
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as FaqaoJcJgtij5MHEBaFy3c_fInkNaiPcIXHBRw_45aF1_OJwMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/Faq.vue?macro=true";
import { default as News_45QRWSD4qoQr_G5WyA50w3zwhMNBsgaXu_45gGEm9_45JCR4Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/News.vue?macro=true";
import { default as Index18RXMP1dEu6MiCeny5Do9jzz6g0TM__45U7H6813CEwYsMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/Index.vue?macro=true";
import { default as usersp8sZuIS1sg7HVlQRvV9ZQup71OOVPL7f1u9hGUUaAUoMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/users.vue?macro=true";
import { default as GuidesO36kDFUAmgqQaNuOzorr_IbKXZ6jklcItG15stfEOskMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/Guides.vue?macro=true";
import { default as LeasesW8vrh4ZmSmmJdKr8IuV7BidPi8Oy8YDPiSk5EVK0a_45IMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/Leases.vue?macro=true";
import { default as BillingkzUlqx2n7QgDT_45ESwVpCaptBwbcWr3ulRyti0gsWbf8Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/Billing.vue?macro=true";
import { default as ExpiredfePTOPOhlS6RBkOxXnwzUD1FynxKVgVK_hzaskyr9XoMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/Expired.vue?macro=true";
import { default as Invoices6GI34oP_JLwEDfi5_45IQUJUtxVDIubVeaGV6SpmI1j_4Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/Invoices.vue?macro=true";
import { default as DashboardYDpGe64wTNJzHbbkGBRbe_x_mYi5y18eYAbMxLOeTpIMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/Dashboard.vue?macro=true";
import { default as EducationTxlIOah6U_45TAC7I_452Bdh7QlcT_45MNP5W16Rh25i8uGe0Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/Education.vue?macro=true";
import { default as SignedOutf9FZIqjU31zI18UgKEShBIUGom_45DC7sN5rKHm0nVg_sMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/SignedOut.vue?macro=true";
import { default as indexe_45MJO0AP5m9R193cXM5oErgK4_HJtG_T4ewFhBKJB0wMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/index.vue?macro=true";
import { default as users9TECkUihzL1aIlp_CqFkefgngNIpjOOgg6xlvtu_45nPwMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/users.vue?macro=true";
import { default as reportsxCzwtabQjtUbkBlY20LlnUX5vuO2k0VL_wjC4lUPAV0Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/reports.vue?macro=true";
import { default as support_ZBSouPPRiP4dk0xO1fL0786nby5P_45K3_45T71ssqlOPQMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/support.vue?macro=true";
import { default as brandingmvUZtz7tfIviEpdjz961Yx1sSJpTKP1Bb50Zz7DBsOQMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/branding.vue?macro=true";
import { default as dashboardO0KR2tV20K4FPibL96DdsTfp8tJy1_B_45b4HH_45EiuW8kMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/dashboard.vue?macro=true";
import { default as indexnnury8owNOCH3G0KNIrJ5hQs5On7eEXsvKqsGbOgSxYMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/quotes/index.vue?macro=true";
import { default as QuotesPanelobcjZ8PmxLYdL_45RaEHjcCXAj8U5OZDvSqVYGhlaZNCIMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/quotes/QuotesPanel.vue?macro=true";
import { default as showjzd78B3eEbFW2sdg2lP_452uKB96FAT0PCG1TVWCtszccMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/show.vue?macro=true";
import { default as createzc2XDDKnGH8qXX6NvBuSloubDbjDGV8tz7swRlzlTP4Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/create.vue?macro=true";
import { default as indext4WTZUcnB_451PQsKiY1FjkMh8AGQpsrOcZklDIgI6lMQMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/quotes/index.vue?macro=true";
import { default as editFQIkbo6uK3SId3VEHEL9LFTjns1Epc_Q5m8HmCbkHAYMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/quotes/[quote_id]/edit.vue?macro=true";
export default [
  {
    name: "Faq",
    path: "/Faq",
    meta: FaqaoJcJgtij5MHEBaFy3c_fInkNaiPcIXHBRw_45aF1_OJwMeta || {},
    alias: ["/frequently-asked-questions"],
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Faq.vue")
  },
  {
    name: "News",
    path: "/News",
    meta: News_45QRWSD4qoQr_G5WyA50w3zwhMNBsgaXu_45gGEm9_45JCR4Meta || {},
    alias: ["/news-and-promotions"],
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/News.vue")
  },
  {
    name: "Index",
    path: "/Index",
    meta: Index18RXMP1dEu6MiCeny5Do9jzz6g0TM__45U7H6813CEwYsMeta || {},
    alias: ["/"],
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Index.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/users.vue")
  },
  {
    name: "Guides",
    path: "/Guides",
    meta: GuidesO36kDFUAmgqQaNuOzorr_IbKXZ6jklcItG15stfEOskMeta || {},
    alias: ["/payroll-guidelines"],
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Guides.vue")
  },
  {
    name: "Leases",
    path: "/Leases",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Leases.vue")
  },
  {
    name: "Billing",
    path: "/Billing",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Billing.vue")
  },
  {
    name: "Expired",
    path: "/Expired",
    meta: ExpiredfePTOPOhlS6RBkOxXnwzUD1FynxKVgVK_hzaskyr9XoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Expired.vue")
  },
  {
    name: "Invoices",
    path: "/Invoices",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Invoices.vue")
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    meta: DashboardYDpGe64wTNJzHbbkGBRbe_x_mYi5y18eYAbMxLOeTpIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Dashboard.vue")
  },
  {
    name: "Education",
    path: "/Education",
    meta: EducationTxlIOah6U_45TAC7I_452Bdh7QlcT_45MNP5W16Rh25i8uGe0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/Education.vue")
  },
  {
    name: "SignedOut",
    path: "/SignedOut",
    meta: SignedOutf9FZIqjU31zI18UgKEShBIUGom_45DC7sN5rKHm0nVg_sMeta || {},
    alias: ["/signed-out"],
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/SignedOut.vue")
  },
  {
    name: "dealer",
    path: "/dealer",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/index.vue")
  },
  {
    name: "dealer-users",
    path: "/dealer/users",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/users.vue")
  },
  {
    name: "dealer-reports",
    path: "/dealer/reports",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/reports.vue")
  },
  {
    name: "dealer-support",
    path: "/dealer/support",
    meta: support_ZBSouPPRiP4dk0xO1fL0786nby5P_45K3_45T71ssqlOPQMeta || {},
    alias: ["/frequently-asked-questions"],
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/support.vue")
  },
  {
    name: "dealer-branding",
    path: "/dealer/branding",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/branding.vue")
  },
  {
    name: "dealer-dashboard",
    path: "/dealer/dashboard",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/dashboard.vue")
  },
  {
    name: "dealer-quotes",
    path: "/dealer/quotes",
    meta: indexnnury8owNOCH3G0KNIrJ5hQs5On7eEXsvKqsGbOgSxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/quotes/index.vue")
  },
  {
    name: "dealer-quotes-QuotesPanel",
    path: "/dealer/quotes/QuotesPanel",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/quotes/QuotesPanel.vue")
  },
  {
    name: "dealer-leads-lead_uuid-show",
    path: "/dealer/leads/:lead_uuid()/show",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/show.vue")
  },
  {
    name: "dealer-leads-lead_uuid-create",
    path: "/dealer/leads/:lead_uuid()/create",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/create.vue")
  },
  {
    name: "dealer-leads-lead_uuid-quotes",
    path: "/dealer/leads/:lead_uuid()/quotes",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/quotes/index.vue")
  },
  {
    name: "dealer-leads-lead_uuid-quotes-quote_id-edit",
    path: "/dealer/leads/:lead_uuid()/quotes/:quote_id()/edit",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dealer/leads/[lead_uuid]/quotes/[quote_id]/edit.vue")
  }
]